import React from 'react';
import { TextInput, Checkbox, InfoIcon } from '@design-system';
import { Tooltip } from '@chakra-ui/react';
import { translations } from 'translations';

interface RfcValidationFieldProps {
  checkboxKey: string;
  signerData: {
    validate_rfc?: boolean;
    rfc?: string;
    advanced?: boolean;
    typed?: boolean;
    autograph?: boolean;
  };
  handleBuildSigner: (field: string, value: any) => void;
  shouldDisableRfcValidation: (signerData: any) => boolean;
  t: (key: string) => string;
  features?: {
    rfc_validation?: {
      enabled?: boolean;
    };
  };
  mode?: 'create' | 'edit';
}

export const RfcValidationField: React.FC<RfcValidationFieldProps> = ({
  checkboxKey,
  signerData,
  handleBuildSigner,
  shouldDisableRfcValidation,
  t,
  features,
  mode = 'create',
}) => {
  if (!features?.rfc_validation?.enabled) {
    return null;
  }

  const tooltipLabel: string = t(
    translations.COMMON.TOOLTIP_ABOUT_RFC_VALIDATION,
  );

  return (
    <div className="mt-3 flex flex-row flex-wrap items-center gap-4">
      <Checkbox
        key={`${checkboxKey}-${
          mode === 'create' ? 'create' : 'edit'
        }-validate_rfc`}
        defaultValue={signerData?.validate_rfc}
        onChange={(e) => handleBuildSigner('validate_rfc', e)}
        disabled={shouldDisableRfcValidation(signerData)}
        label={`${t(translations.COMMON.VALIDATE_RFC)}`}
      />

      <TextInput
        className="h-[30px] w-[181px]  [&+label]:top-1/2 [&+label]:-translate-y-1/2 [&+label]:text-sm"
        placeholder={`${t(translations.COMMON.ENTER_EXPECTED_RFC)}`}
        isFullWidth
        disabled={
          !signerData?.validate_rfc || shouldDisableRfcValidation(signerData)
        }
        id="rfc"
        name="rfc"
        defaultValue={signerData?.rfc}
        value={signerData?.rfc}
        onChange={(e) => handleBuildSigner('rfc', e.target.value)}
      />
      <Tooltip
        label={tooltipLabel}
        placement="top"
        bg="black"
        color="white"
        fontSize="sm"
        hasArrow
        px={4}
        py={3}
        rounded="2xl"
      >
        <span style={{ display: 'inline-flex' }}>
          <InfoIcon
            color={
              signerData.typed == true || signerData.autograph == true
                ? '#8513C2'
                : 'gray'
            }
          />
        </span>
      </Tooltip>
    </div>
  );
};
